/**
 * Standard structure for quote filter payloads
 */
export default class QuoteFilterPayload {
  /**
   * Whether this is a trip insurance category
   * @type {Boolean}
   */
  is_trip = false;

  /**
   * The quote ID from the store
   * @type {String}
   */
  quote_id = null;

  /**
   * The category ID for the insurance type
   * @type {Number}
   */
  category_id = null;

  /**
   * Filter details
   * @type {Object}
   */
  filter = {
    /**
     * Selected filter slugs (checkboxes)
     * @type {Object}
     */
    filter_slugs: {},

    /**
     * Coverage details
     * @type {Object}
     */
    coverage: {
      /**
       * Coverage ID
       * @type {Number}
       */
      id: 0,

      /**
       * Coverage amount value
       * @type {Number}
       */
      amount: 0,
    },

    /**
     * Sort option
     * @type {Number}
     */
    sortOption: 0,

    /**
     * Plan-specific selections, keyed by api_plan_name
     * @type {Object.<string, import('./PlanSelection').default>}
     */
    planSelections: {},
  };
}
